import { inject, isDevMode, provideAppInitializer } from '@angular/core';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';
import { TranslocoHttpLoader } from '../utilities/transloco-loader.utils';
import { SystemLanguage } from '@dss-libs/shared/type/common-types';
import { tap } from 'rxjs';

function getBrowserLang(): SystemLanguage {
  const languageRegionCode = navigator.language;
  const languageCode = languageRegionCode.substring(0, 2);
  for (const language of Object.values(SystemLanguage)) {
    if (languageCode === language) {
      return languageCode as SystemLanguage;
    }
  }
  return SystemLanguage.English;
}

/**
 * Provides transloco with the configures languages and loads the language before the app boots up.
 * @param useBrowserLang - If true, the browser language will be used.
 */
export function provideTranslocoWithConfig(useBrowserLang = false) {
  return [
    provideAppInitializer(() => {
      const translocoService = inject(TranslocoService);

      if (useBrowserLang) {
        return translocoService.load(getBrowserLang()).pipe(
          tap(() => {
            translocoService.setActiveLang(getBrowserLang());
          })
        );
      }
      return translocoService.load(translocoService.getDefaultLang());
    }),
    provideTransloco({
      config: {
        availableLangs: [SystemLanguage.English, SystemLanguage.Arabic, SystemLanguage.French, SystemLanguage.Danish],
        defaultLang: SystemLanguage.English,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ];
}
